import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { faqs } from '../mock';

const FAQ = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-50 to-emerald-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-slate-900 mb-6">Frequently Asked Questions</h1>
            <p className="text-xl text-slate-600">
              Find answers to common questions about our services, booking process, and policies
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq) => (
                <AccordionItem
                  key={faq.id}
                  value={`item-${faq.id}`}
                  className="border border-sky-100 rounded-lg px-6 bg-white hover:shadow-md transition-shadow"
                >
                  <AccordionTrigger className="text-left hover:no-underline">
                    <span className="font-semibold text-slate-900">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 pt-2">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            {/* Still Have Questions */}
            <div className="mt-12 text-center bg-gradient-to-br from-sky-50 to-emerald-50 rounded-lg p-8">
              <h3 className="text-2xl font-bold text-slate-900 mb-3">Still Have Questions?</h3>
              <p className="text-slate-600 mb-6">
                We're here to help! Contact us and we'll be happy to answer any questions you may have.
              </p>
              <Link to="/contact">
                <Button size="lg" className="bg-sky-600 hover:bg-sky-700">
                  Contact Us <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
